import { render, staticRenderFns } from "./CommMng.vue?vue&type=template&id=47b3aaea&scoped=true&"
import script from "./CommMng.vue?vue&type=script&lang=js&"
export * from "./CommMng.vue?vue&type=script&lang=js&"
import style0 from "./CommMng.vue?vue&type=style&index=0&id=47b3aaea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b3aaea",
  null
  
)

export default component.exports